/**
 * Projects Module Routes — grid + detail (PRD 1, EPIC 1.4, Story 1.4.5).
 *
 * Permissions follow V1/backend/app/db/seeds/projects_permissions_seed.py:
 *   - projects:read   (used here pra ambas as rotas)
 *   - projects:create (POST /api/v1/projects, gated server-side)
 *   - projects:update (archive / edit / milestones, gated server-side)
 *   - projects:delete (admin only, gated server-side)
 *
 * Edição rica e wizard de criação ficam pra Story 1.4.6+.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const ProjectsPage = lazy(() => import("@/pages/projects/ProjectsPage"));
const ProjectDetailPage = lazy(() => import("@/pages/projects/ProjectDetailPage"));
// Time Tracking Dashboard agregado (Story E11.2.4) — global, com filtros por
// projeto/usuário/período. Permissão tasks:read (mesmo gate dos time logs).
const TimeTrackingDashboardPage = lazy(() => import("@/pages/projects/TimeTrackingDashboardPage"));

export const projectsRoutes: ModuleRoutes = {
  moduleId: "projects",
  basePath: "/projects",
  routes: [
    {
      path: "/projects",
      element: <ProjectsPage />,
      permission: { resource: "projects", action: "read" },
    },
    {
      // Static segment — RR v6 ranqueia acima de "/projects/:id" mesmo aqui.
      path: "/projects/time-tracking",
      element: <TimeTrackingDashboardPage />,
      permission: { resource: "tasks", action: "read" },
    },
    {
      path: "/projects/:id",
      element: <ProjectDetailPage />,
      permission: { resource: "projects", action: "read" },
    },
  ],
};
